import React from "react";

const sections = [
  {
    titleVi: "Giới thiệu",
    titleEn: "Introduction",
    contentVi:
      "Jade Spring tôn trọng quyền riêng tư của người dùng và cam kết bảo vệ thông tin cá nhân của bạn. Chính sách này giải thích cách chúng tôi thu thập, sử dụng và bảo vệ thông tin khi bạn sử dụng ứng dụng Jade Spring.",
    contentEn:
      "Jade Spring respects your privacy and is committed to protecting your personal information. This Privacy Policy explains how we collect, use, and protect information when you use the Jade Spring application.",
  },
  {
    titleVi: "Thông tin chúng tôi thu thập",
    titleEn: "Information We Collect",
    listVi: [
      "Thông tin thiết bị (loại thiết bị, hệ điều hành).",
      "Thông tin phân tích sử dụng ứng dụng.",
      "Thông tin lỗi ứng dụng và nhật ký kỹ thuật.",
      "Dữ liệu người dùng nhập để phục vụ tính toán phong thủy.",
    ],
    listEn: [
      "Device information (device type, operating system).",
      "Application usage analytics.",
      "Crash reports and technical logs.",
      "User-provided information for Feng Shui calculations.",
    ],
  },
  {
    titleVi: "Mục đích sử dụng thông tin",
    titleEn: "How We Use Information",
    listVi: [
      "Cung cấp các tính năng phân tích phong thủy.",
      "Cải thiện trải nghiệm người dùng.",
      "Khắc phục lỗi và nâng cao hiệu suất ứng dụng.",
      "Phát triển tính năng mới.",
      "Hỗ trợ khách hàng.",
    ],
    listEn: [
      "Provide Feng Shui analysis features.",
      "Improve user experience.",
      "Fix bugs and improve performance.",
      "Develop new features.",
      "Provide customer support.",
    ],
  },
  {
    titleVi: "Dịch vụ bên thứ ba",
    titleEn: "Third-Party Services",
    contentVi:
      "Jade Spring có thể sử dụng Firebase Analytics, Firebase Crashlytics hoặc các công cụ tương tự để cải thiện chất lượng dịch vụ.",
    contentEn:
      "Jade Spring may use Firebase Analytics, Firebase Crashlytics, or similar services to improve service quality.",
  },
  {
    titleVi: "Chia sẻ dữ liệu",
    titleEn: "Data Sharing",
    contentVi:
      "Chúng tôi không bán hoặc cho thuê thông tin cá nhân của người dùng.",
    contentEn:
      "We do not sell or rent users' personal information.",
    listVi: [
      "Theo yêu cầu pháp luật.",
      "Ngăn chặn gian lận hoặc vi phạm pháp luật.",
      "Làm việc với nhà cung cấp dịch vụ đáng tin cậy.",
    ],
    listEn: [
      "Required by law.",
      "Prevent fraud or illegal activity.",
      "Working with trusted service providers.",
    ],
  },
  {
    titleVi: "Bảo mật dữ liệu",
    titleEn: "Data Security",
    contentVi:
      "Chúng tôi áp dụng các biện pháp kỹ thuật hợp lý để bảo vệ dữ liệu khỏi truy cập trái phép, mất mát hoặc thay đổi.",
    contentEn:
      "We implement reasonable technical measures to protect data against unauthorized access, loss, or alteration.",
  },
  {
    titleVi: "Lưu trữ dữ liệu",
    titleEn: "Data Retention",
    contentVi:
      "Dữ liệu chỉ được lưu giữ trong thời gian cần thiết để cung cấp dịch vụ hoặc đáp ứng nghĩa vụ pháp lý.",
    contentEn:
      "Information is retained only as long as necessary to provide services or comply with legal obligations.",
  },
  {
    titleVi: "Quyền của người dùng",
    titleEn: "User Rights",
    listVi: [
      "Yêu cầu truy cập dữ liệu cá nhân.",
      "Yêu cầu chỉnh sửa dữ liệu.",
      "Yêu cầu xóa dữ liệu.",
      "Rút lại sự đồng ý xử lý dữ liệu.",
    ],
    listEn: [
      "Request access to personal data.",
      "Request correction of personal data.",
      "Request deletion of personal data.",
      "Withdraw consent for data processing.",
    ],
  },
  {
    titleVi: "Quyền riêng tư của trẻ em",
    titleEn: "Children's Privacy",
    contentVi:
      "Ứng dụng không dành cho trẻ em dưới 13 tuổi và chúng tôi không cố ý thu thập dữ liệu từ trẻ em.",
    contentEn:
      "The application is not intended for children under 13 years old, and we do not knowingly collect information from children.",
  },
  {
    titleVi: "Thay đổi chính sách",
    titleEn: "Changes to This Policy",
    contentVi:
      "Chúng tôi có thể cập nhật Chính sách quyền riêng tư theo thời gian. Những thay đổi sẽ được đăng tải trên trang này.",
    contentEn:
      "We may update this Privacy Policy from time to time. Any changes will be posted on this page.",
  },
];

export default function PrivacyPolicy() {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "#f8fafc",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          maxWidth: 1000,
          margin: "0 auto",
          background: "#fff",
          borderRadius: 24,
          padding: 40,
          boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
        }}
      >
        <div style={{ textAlign: "center", marginBottom: 40 }}>
          <h1
            style={{
              fontSize: 42,
              color: "#0f766e",
              marginBottom: 10,
            }}
          >
            Jade Spring
          </h1>

          <h2
            style={{
              fontSize: 28,
              marginBottom: 12,
            }}
          >
            Privacy Policy
          </h2>

          <p style={{ color: "#64748b" }}>
            Chính sách quyền riêng tư / Privacy Policy
          </p>

          <p style={{ color: "#94a3b8" }}>
            Last Updated: January 6, 2026
          </p>
        </div>

        {sections.map((section, index) => (
          <div
            key={index}
            style={{
              marginBottom: 36,
              paddingBottom: 24,
              borderBottom: "1px solid #e2e8f0",
            }}
          >
            <h3
              style={{
                color: "#0f766e",
                marginBottom: 16,
                fontSize: 24,
              }}
            >
              {index + 1}. {section.titleVi} / {section.titleEn}
            </h3>

            {section.contentVi && (
              <>
                <p>
                  <strong>Tiếng Việt:</strong>
                </p>
                <p>{section.contentVi}</p>
              </>
            )}

            {section.contentEn && (
              <>
                <p>
                  <strong>English:</strong>
                </p>
                <p>{section.contentEn}</p>
              </>
            )}

            {section.listVi && (
              <>
                <p>
                  <strong>Tiếng Việt:</strong>
                </p>
                <ul>
                  {section.listVi.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {section.listEn && (
              <>
                <p>
                  <strong>English:</strong>
                </p>
                <ul>
                  {section.listEn.map((item, i) => (
                    <li key={i}>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        ))}

        <div>
          <h3
            style={{
              color: "#0f766e",
              marginBottom: 16,
            }}
          >
            11. Liên hệ / Contact Us
          </h3>

          <p>
            Nếu bạn có câu hỏi về Chính sách quyền riêng tư, vui lòng liên hệ
            với chúng tôi.
          </p>

          <p>
            If you have any questions regarding this Privacy Policy, please
            contact us.
          </p>

          <div
            style={{
              background: "#f1f5f9",
              padding: 20,
              borderRadius: 16,
              marginTop: 16,
            }}
          >
            <strong>Jade Spring Support</strong>
            <br />
            Email: leky.developer@gmail.com
          </div>
        </div>

        <div
          style={{
            marginTop: 40,
            textAlign: "center",
            color: "#94a3b8",
          }}
        >
          © {new Date().getFullYear()} Jade Spring. All Rights Reserved.
        </div>
      </div>
    </div>
  );
}